<script>
  import options from './ActiveGroups.options'
  export default options
</script>

<template>
  <article class="kb-active-groups">
    <div class="kb-active-groups__header" v-if="showNotMemberComponents">
      <h2 class="kb-active-groups__header-title">{{ getLabel('noGroupsTitle') }}</h2>
      <p class="kb-active-groups__header-description">{{ getLabel('noGroupsText') }}</p>
    </div>

    <span v-if="!isSearching && groups?.length > 0" class="kb-active-groups__count">{{ groups?.length }} {{ getLabel('groups') }}</span>
    <ul class="kb-active-groups__list" :class="{ 'kb-active-groups__list--grid': showNotMemberComponents }">
      <template v-for="item, index in groups" :key="index">

        <li class="kb-active-groups__list-item">
          <template v-if="item.isSpotCard">
            <SpotCard v-if="!showNotMemberComponents" :spotCardData="item" /> 
          </template>
          <template v-else>
            <ThemeCard
              v-if="showNotMemberComponents" 
              :content="item"
            />
      
            <GroupDetails 
              v-else
              :id="item.id"
              :svgIcon="item.svgIcon"
              :colorTheme="item.colorTheme"
              :title="item.title"
              :type="item.theme"
              :updates="item.users"
              :link="item.href"
            />
          </template>
        </li>
      </template>  
    </ul>

    <template v-if="isSearching">
      <div class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
      </div>
    </template>

  </article>
</template>
